import React from 'react';

export default function Notification(props) {
   let { notificationType, notification } = props;

   const renderType = () => {
      let classType;
      switch (notificationType) {
         case 'info':
            classType = 'is-success is-light';
            break;
         case 'warning':
            classType = 'is-warning is-light';
            break;
         case 'danger':
            classType = 'is-danger is-light';
            break;
         case 'is-hidden':
            classType = 'is-hidden';
            break;
         default:
            classType = 'is-hidden';
            break;
      }
      return classType;
   };

   return (
      <div className={`notification ${renderType()}`}>
         {/* <button className='delete'></button> */}
         <p>{notification}</p>
      </div>
   );
}
